
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltySubscriptionAddForm from '@/form/loyalty/loyaltySubscription/LoyaltySubscriptionAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltySubscriptionAddComponent extends Vue {
    @Prop() readonly form!: LoyaltySubscriptionAddForm;
    constructor() {
        super();
    }
}
